(() => {
  'use strict';
  const instances = new WeakMap();

  function init(root) {
    if (instances.has(root)) return;
    const controller = new AbortController();
    const signal = controller.signal;
    const mobileMenu = root.querySelector('[data-ufc-mobile-menu]');
    const menuLabel = root.querySelector('[data-ufc-menu-label]');
    const media = window.matchMedia('(max-width: 1023px)');
    const closeAll = () => root.querySelectorAll('details[open]').forEach(detail => { detail.open = false; });

    root.addEventListener('toggle', event => {
      const detail = event.target;
      if (detail === mobileMenu && menuLabel) menuLabel.textContent = detail.open ? 'Close' : 'Menu';
      if (detail.open && detail.matches('.ufc-desktop-nav [data-ufc-disclosure]')) {
        root.querySelectorAll('.ufc-desktop-nav details[open]').forEach(other => {
          if (other !== detail) other.open = false;
        });
      }
    }, { capture: true, signal });

    root.addEventListener('keydown', event => {
      if (event.key !== 'Escape') return;
      const detail = event.target.closest('details[open]') || root.querySelector('details[open]');
      if (!detail) return;
      event.preventDefault();
      detail.open = false;
      detail.querySelector('summary')?.focus();
    }, { signal });

    root.addEventListener('click', event => {
      if (!event.target.closest('a[href]') || !mobileMenu?.open) return;
      closeAll();
    }, { signal });

    document.addEventListener('click', event => {
      if (!root.contains(event.target)) closeAll();
    }, { signal });

    if (media.addEventListener) media.addEventListener('change', closeAll);
    else media.addListener(closeAll);
    instances.set(root, () => {
      controller.abort();
      if (media.removeEventListener) media.removeEventListener('change', closeAll);
      else media.removeListener(closeAll);
      instances.delete(root);
    });
  }

  function mount(scope) {
    if (scope.matches?.('[data-ufc-header]')) init(scope);
    scope.querySelectorAll('[data-ufc-header]').forEach(init);
  }

  mount(document);
  document.addEventListener('shopify:section:load', event => mount(event.target));
  document.addEventListener('shopify:section:unload', event => {
    event.target.querySelectorAll('[data-ufc-header]').forEach(root => instances.get(root)?.());
  });
})();
